import {
  logout,
  getAccountSettings,
  getEmailSenders,
  getUsers,
  companyFeature
} from "@/api/accounts";

import { getToken } from "@/api/auth.js";

export default {
  async logout() {
    logout().then(() => {
      window.sessionStorage.removeItem("selected_location");
      window.sessionStorage.removeItem("segment_id");
      localStorage.setItem("tokenData", '{}'); 
      // location.reload();
    });
  },
  async getAccountSettings({ commit }) {
    const response = await getAccountSettings();
    commit("setAccountSettings", response);
  },
  async getEmailSenders({ commit }) {
    const response = await getEmailSenders();
    commit("setEmailSenders", response);
  },
  async getUsers({ commit }) {
    const response = await getUsers();
    commit("setUsers", response);
  },
  async getToken({commit}){
    const response = await getToken()
    commit("setTokenData",response);
  },
  async logoutToken({commit}){
    commit("setTokenData",{});
  },
  async featurePage({ commit }) {
    const response = await companyFeature();
    commit("setFeaturePage", response);
  },
};
